module.exports = {"title":"Einloggen","emailPH":"Email","pwdPH":"Passwort","submitTxt":"Einloggen","errMsg":"Deine Anmeldung war nicht erfolgreich","registerHint1":"Noch keinen Account ?","registerHint2":"Hier geht es zur Anmeldung"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/login/pl.json
// module id = wbZI
// module chunks = 1